<!--
 * @Author: 
 * @LastEditTime: 2022-07-26 17:09:45
 * @Description: 
-->
<template>
  <div class="circle-item">
    <img src="../images/oterInfo.png" />
  </div>
</template>

<script>
export default {
  name: 'OtherInfo',
}
</script>

<style lang="scss" scoped>

.circle-item {
  position: relative;
}
@import './specialStyle.scss';

</style>
